import { getUserConfiguration } from 'owa-session-store';
import loc from 'owa-localize';
import { doNotShowAgainMessage } from './ForgottenAttachmentsDialogToggle.locstring.json';
import * as React from 'react';
import { updateUserConfiguration, updateUserOptions } from 'owa-options-core';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { observer } from 'mobx-react-lite';

export const ForgottenAttachmentsDialogToggle = observer<{}>(() => {
    const userOptions = getUserConfiguration().UserOptions;

    // As the text is "Do not show this message again" so it is
    // off if we have to check for forgottent attachment and on
    // when we don't.
    return (
        <Toggle
            defaultChecked={!userOptions.CheckForForgottenAttachments}
            onText={loc(doNotShowAgainMessage)}
            offText={loc(doNotShowAgainMessage)}
            onChange={onChange}
        />
    );
});

async function onChange(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) {
    // As the text is "Do not show this message again" so checked means
    // that user doesn't want to check for fogotten attachments
    const checkForForgottentAttachments = !checked;

    updateUserOptions({
        CheckForForgottenAttachments: checkForForgottentAttachments,
    });
    try {
        await updateUserOptionsConfiguration(checkForForgottentAttachments);
    } catch {
        updateUserOptions({
            CheckForForgottenAttachments: !checkForForgottentAttachments,
        });
    }
}

async function updateUserOptionsConfiguration(checkForForgottenAttachments: boolean) {
    await updateUserConfiguration(
        [
            {
                propertyName: 'CheckForForgottenAttachments',
                propertyType: 'Boolean',
                propertyValue: `${checkForForgottenAttachments}`,
            },
        ],
        'OWA.UserOptions'
    );
}
